import "./skills.css";

const columns = [
  {
    variant: "light",
    eyebrow: "For teams still doing it manually",
    title: "Automate",
    tagline: "ELIMINATE THE MANUAL DRAG.",
    description: <>Your team is burning hours on work that should run itself. I map your operations from end to end and build the automation foundation that <span className="skills__keyword">scales</span> with you.</>,
    bullets: [
      "Full process mapping session",
      "Prioritised automation roadmap",
      "Automations built and deployed",
      "Documentation and team walkthrough included",
    ],
  },
  {
    variant: "mid",
    eyebrow: "For teams with too many tools",
    title: "Integrate",
    tagline: "MAKE YOUR TOOLS ACTUALLY TALK.",
    description: <>Your stack keeps growing but nothing connects. I come in, find the gaps, <span className="skills__keyword">fix</span> the plumbing and give you a clear picture of what to fix first.</>,
    bullets: [
      "Full tools and workflow audit",
      "Integration gap and redundancy analysis",
      "Connections built and tested",
      "Prioritised integration roadmap",
    ],
  },
  {
    variant: "dark",
    eyebrow: "For teams with legacy debt",
    title: "Overhaul",
    tagline: "FIX WHAT'S SILENTLY COSTING YOU.",
    description: <>You have legacy systems and capacity leaking somewhere — but no one has diagnosed it yet. I <span className="skills__keyword">audit</span>, identify, and build the fix without a full rebuild.</>,
    bullets: [
      "ERP, CRM and integration landscape review",
      "Bottleneck and data flow analysis",
      "Executive summary and fix plan",
      "Phased implementation. No full rebuild required.",
    ],
  },
];

const Skills = () => {
  return (
    <section className="skills section" id="skills">
      <div className="skills__heading">
        <span className="section__eyebrow">Where do you start?</span>
        <h2 className="skills__main-title">Choose Your Path.</h2>
        <p className="skills__main-subtitle">Three ways to work together. Pick the one that fits where you are.</p>
      </div>

      <div className="skills__grid-wrap container">
      <div className="skills__grid">
        {columns.map((col, i) => (
          <div key={i} className={`skills__col skills__col--${col.variant}`}>
            <span className="skills__col-eyebrow">{col.eyebrow}</span>
            <h3 className="skills__col-title">{col.title}</h3>
            <span className="skills__col-tagline">{col.tagline}</span>
            <p className="skills__col-desc">{col.description}</p>
            <hr className="skills__divider" />
            <span className="skills__deliverables-label">What you get</span>
            <ul className="skills__bullets">
              {col.bullets.map((b, j) => (
                <li key={j}>{b}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      </div>

      <div className="skills__cta">
        <p className="skills__cta-question">Not sure which one fits?</p>
        <p className="skills__cta-sub">Book a free discovery call and we'll figure it out together.</p>
        <a href="#contact" className="button button--flex skills__cta-btn">
          Book a Free Discovery Call
        </a>
      </div>
    </section>
  );
};

export default Skills;
